import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { FontIcon } from 'material-ui';

export class FontAwesome extends Component {
  static propTypes = {
    name: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.any,
    className: PropTypes.string,
    tooltip: PropTypes.string,
  };

  render() {
    if (!this.props.name) {
      return null;
    }

    const { name, onClick, style, className, tooltip } = this.props;

    const icon = (
      <FontIcon
        onClick={() => onClick && onClick()}
        style={style}
        className={['fa', `fa-${name}`, className].filter(Boolean).join(' ')}
      />
    );

    if (tooltip && tooltip !== '') {
      return (
        <Tooltip title={tooltip}>
          <span style={{ display: 'inline-flex', cursor: onClick ? 'pointer' : 'inherit' }}>
            {icon}
          </span>
        </Tooltip>
      );
    }

    return icon;
  }
}
